import MapObject from '@/models/MapObject'

class MapUserLocation extends MapObject {
    identifier = 'gid'

    object_name = 'MapUserLocation'

    getLabel() {
        if (this.user.callsign) {
            return this.user.callsign
        }

        return this.user.user ? this.user.user.name : this.user.gid
    }

    setVisible(visible) {
        this.settings.visible = visible
    }
}

export default MapUserLocation
